<template>
  <a-layout id="components-layout-demo-top-side-2">
    <a-layout-header
      :style="{
        height: '50px',
        lineHeight: '50px',
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        zIndex: '20'
      }"
      class="header"
    >
      <router-link to="/overview">
        <div class="logo"></div>
      </router-link>

      <p
        style="
          padding-left: 48px;
          font-size: 20px;
          line-height: 50px;
          font-weight: bold;
          letter-spacing: 2px;
      "
      >视图计算</p>
      <!-- <a-menu
        theme="dark"
        mode="horizontal"
        :defaultSelectedKeys="[getIndex()]"
        :selectedKeys="[getIndex()]"
        :style="{ lineHeight: '50px', width: menuWidth }"
        @click="changeSelect"
      >
        <a-menu-item v-for="item in menuInfo" :key="item.index">
          <router-link :to="item.path">
            <span>{{ item.name }}</span>
          </router-link>
        </a-menu-item>
      </a-menu>-->

      <div class="main-head">
        <a-select
          :default-value="m"
          @change="boxChange"
          class="main-select"
          style="margin-right: 10px"
          v-if="d && m"
        >
          <a-select-opt-group>
            <span slot="label">企业账号：</span>
            <a-select-option :key="t.qid" :value="t.qid" v-for="t in d">
              <heart-icon v-if="t.is_owner == 1" />
              <user-icon v-else />
              {{ t.enterprise_name || t.qid }}
              <a-tag color="orange" v-if="t.is_owner == 1">拥有者</a-tag>
              <!-- <a-tag color="green" v-if="t.user_level == 1"> 试用 </a-tag> -->
            </a-select-option>
          </a-select-opt-group>
        </a-select>
        <div class="main-head-popover">
          <a-avatar
            :src="avatar"
            icon="user"
            style="
              width: 32px;
              height: 32px;
              line-height: 32px;
              border: 0;
              background: 0;
              display: flex;
              align-items: center;
              justify-content: flex-end;
              cursor: pointer;
              padding: 0;
            "
          />
          <div class="main-head-hover" v-show="showPanel">
            <div class="main-head-hover-1">
              <a-avatar :src="avatar" icon="user" />
              <span>{{ userName }}</span>
            </div>
            <div class="main-head-hover-2">
              版本信息：
              <a-tag color="orange" v-if="user.user_level == 1">试用版</a-tag>
              <a-tag color="green" v-else-if="user.user_level == 2">正式版</a-tag>
              <a-tag color="gray" v-else>未知版</a-tag>
            </div>
            <div class="main-head-hover-3">
              到期时间：{{ user.expire_time }}
              <a-tag color="gray" style="margin-left: 10px" v-if="user.expire_status == 3">已过期</a-tag>
              <a-tag color="orange" style="margin-left: 10px" v-if="user.expire_status == 2">即将到期</a-tag>
            </div>
            <div class="main-head-hover-4">边缘服务器激活码可用数：{{ user.surplus_count }}</div>
            <a @click="confirm" class="main-head-hover-5" href="#">退出账号</a>
          </div>
        </div>
        <!-- <a-popover placement="bottom" v-if="user">
          <template slot="content">
            <div>
              版本信息：
              <a-tag color="orange" v-if="user.user_level == 1"> 试用版 </a-tag>
              <a-tag color="green" v-else-if="user.user_level == 2">
                正式版
              </a-tag>
              <a-tag color="gray" v-else> 未知版 </a-tag>
            </div>
            <p>Content</p>
          </template>
          <template slot="title">
            <a-avatar icon="user" :src="avatar" />
            <span>{{ userName }}</span>
          </template>
          <a-button
            style="
              height: 50px;
              line-height: 50px;
              border: 0;
              background: 0;
              display: flex;
              align-items: center;
              justify-content: flex-end;
              cursor: pointer;
              padding: 0;
            "
          >
            <span>
              <a-badge :count="msgCount">
                <a-avatar icon="user" :src="avatar" />
              </a-badge>
            </span>
          </a-button>
        </a-popover>-->
        <!-- <a-dropdown placement="bottomCenter">
          <a-menu slot="overlay">
            <a-menu-item disabled>{{ userName }}</a-menu-item>
            <span class="main-head-name" slot="label"></span>
            <a-menu-divider />
        <a-menu-item>-->
        <!-- <a rel="noopener noreferrer" href="https://i.360.cn/"> -->
        <!-- <a-icon type="user" /> -->
        <!-- <center-icon />360用户中心 -->
        <!-- </a> -->
        <!-- </a-menu-item> -->
        <!-- <a-menu-item>
              <a rel="noopener noreferrer" @click="gotoUser">
                <a-icon type="user" />用户中心
              </a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>-->
        <i class="main-head-line">|</i>
        <a-popconfirm
          @cancel="cancel"
          @confirm="confirm"
          cancel-text="取消"
          ok-text="退出"
          title="确认退出当前账号吗?"
        >
          <a class="main-head-quit" href="#">退出</a>
        </a-popconfirm>
      </div>
    </a-layout-header>
    <a-layout class="main">
      <a-layout-sider class="main-menu-sider" collapsed v-if="showPage">
        <a-menu
          :defaultSelectedKeys="[getIndex()]"
          :selectedKeys="[getIndex()]"
          @click="changeSelect"
          class="main-menu-container"
          mode="inline"
          theme="dark"
        >
          <a-menu-item
            :key="item.index"
            class="main-menu"
            style="padding: 0 20px !important"
            v-for="item in menuInfo"
          >
            <!-- <router-link :to="item.path"> -->
            <i :class="icon[item.index]"></i>
            <a @click="handelClickLink(item)" class="main-menu-item">
              <!-- <a-icon :class="icon[item.index]" /> -->
              <span>{{ item.name }}</span>
            </a>
            <!-- </router-link> -->
          </a-menu-item>
        </a-menu>
      </a-layout-sider>
      <a-layout-content class="main-container">
        <router-view ref="container" v-if="showPage" />
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import global from "../../utils/Global";

var infos = [];
// for (var i = 0; i < global.menuInfo.length; i++) {
//   if (global.menuInfo[i].index < 100) {
//     infos.push(global.menuInfo[i])
//   }
// }

const HeartIcon = {
  template: `
    <a-icon :component="HeartSvg" />
  `,
  data () {
    return {
      HeartSvg
    };
  }
};
const centerIcon = {
  template: `
    <a-icon :component="centerSvg" />
  `,
  data () {
    return {
      centerSvg
    };
  }
};
const centerSvg = {
  template: `
    <svg t="1608174915464" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2718" width="200" height="200"><path d="M680.416757 459.07972 573.090357 459.07972 573.090357 351.753319c0-30.312376-24.800849-55.113225-55.113225-55.113225l0 0c-30.312376 0-55.113225 24.800849-55.113225 55.113225l0 107.326401L355.537506 459.07972c-30.312376 0-55.113225 24.800849-55.113225 55.113225l0 0c0 30.312376 24.800849 55.113225 55.113225 55.113225l107.326401 0 0 107.326401c0 30.312376 24.800849 55.113225 55.113225 55.113225l0 0c30.312376 0 55.113225-24.800849 55.113225-55.113225L573.090357 569.30617l107.326401 0c30.312376 0 55.113225-24.800849 55.113225-55.113225l0 0C735.529983 483.880569 710.729134 459.07972 680.416757 459.07972z" p-id="2719" fill="#1afa29"></path><path d="M511.771803 76.893274c-239.630682 0-435.106726 195.47195-435.106726 435.103656 0 94.841042 30.642904 182.753277 82.499969 254.379595 13.024641 20.517289 32.243355 42.841737 59.010999 66.24168 77.483722 71.033823 180.62787 114.488521 293.595758 114.488521 103.163591 0 198.122313-36.252669 272.847202-96.638991 0.907673-0.728594 1.814322-1.456165 2.716878-2.192945 0.475837-0.38988 0.954745-0.775666 1.425466-1.165546 22.744004-18.662035 43.799552-39.940664 62.682621-63.755046 59.665915-74.495668 95.433536-168.876222 95.433536-271.356244C946.877505 272.370341 751.405555 76.893274 511.771803 76.893274zM829.009004 763.432473c-66.787102 37.028335-141.208069 57.060577-188.409091 66.422805-90.930989 18.152429-200.3654-12.568247-240.679571-31.591509-68.068282-32.116465-89.183182-64.577784-124.267235-97.739045l-20.070104-19.195178c-47.562249-44.911886-98.123808-39.531342-113.870444-4.776793-22.51069-50.329269-35.056424-106.024755-35.056424-164.555823 0.001023-92.624561 31.394011-178.147376 84.049255-246.521626 68.905346-40.120766 147.548474-61.442374 196.569958-71.193459 91.102904-18.147312 200.535269 12.568247 240.679571 31.592532 68.240197 32.115442 89.182158 64.576761 124.43915 97.91403l20.070104 19.023262c47.082318 44.544519 95.120404 38.818097 109.209284 4.267187 22.610974 50.424436 35.21299 106.243743 35.21299 164.91705C916.885424 606.854345 883.972826 694.26516 829.009004 763.432473z" p-id="2720" fill="#1afa29"></path></svg>
    `
};
const HeartSvg = {
  template: `
    <svg t="1608176020226" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2849" width="200" height="200"><path d="M1000.102712 846.937125L986.516554 898.384709c-4.994911 18.980662-24.375166 30.169263-43.25593 24.974556l-11.488296-3.096845c-4.795115 6.493384-9.989822 12.786972-15.883817 18.680967-2.79715 2.79715-5.893995 4.994911-8.791044 7.592265 0.399593 0.899084 1.09888 1.69827 1.398576 2.697252l4.695216 17.082596c5.194708 18.880764-5.893995 38.261019-24.674861 43.156032l-50.948093 13.386362c-18.780866 4.895013-38.161121-6.393486-43.355828-25.274251l-2.79715-10.389415c-20.678932-0.799186-41.257966-4.994911-60.638221-13.386361l-8.591247 8.591247c-13.785955 13.885853-36.163156 13.785955-50.049009-0.099898l-37.561732-37.761528c-13.885853-13.885853-13.885853-36.362953-0.099898-50.248806l8.591247-8.591247c-6.593283-15.18453-10.68911-31.068347-12.687074-47.251859l-11.78799-3.196743c-18.880764-5.094809-30.169263-24.674861-25.074454-43.555625L606.903311 740.245824c4.994911-18.980662 24.375166-30.169263 43.25593-24.974556l11.488295 3.096845c4.795115-6.493384 9.989822-12.786972 15.883818-18.680967 8.890942-8.99084 18.780866-16.28341 29.070382-22.776795l-1.298677-4.595318c-5.194708-18.880764 5.893995-38.261019 24.674861-43.156032l50.948093-13.386361c18.780866-4.895013 38.161121 6.393486 43.355829 25.27425l3.596336 13.386361c11.887888 2.297659 23.57598 5.494402 34.864479 10.389415l8.591247-8.591247c13.785955-13.885853 36.163156-13.785955 50.049009 0.099899l37.561732 37.761527c13.885853 13.885853 13.885853 36.362953 0.099898 50.248806l-8.591247 8.591247c6.593283 15.18453 10.68911 31.068347 12.687074 47.251859l11.78799 3.196743c18.880764 5.094809 30.169263 24.674861 25.174352 43.555625zM796.610034 716.969538c-56.442495 0-102.195881 45.753386-102.195881 102.195881s45.753386 102.195881 102.195881 102.195881S898.805915 875.607915 898.805915 819.165419c0.099898-56.442495-45.753386-102.195881-102.195881-102.195881zM776.130899 553.436149c0 22.576998-18.281375 40.858373-40.858373 40.858373-12.187583 0-22.976591-5.394504-30.468958-13.885853l-0.899084 1.198779c-57.641274-31.068347-123.474202-48.650434-193.502856-48.650434-225.86988 0-408.98332 183.113441-408.98332 408.98332 0 22.576998-18.281375 40.858373-40.858373 40.858373-22.576998 0-40.858373-18.281375-40.858372-40.858373 0-214.681279 138.059343-396.695839 330.163623-463.327953-63.834964-48.550536-105.192828-125.172472-105.192828-211.584434 0-146.850386 118.978782-265.929067 265.829169-265.929067s265.829168 119.07868 265.829168 265.929067c0 86.411962-41.357864 162.934-105.192828 211.584434 28.67079 9.989822 56.042902 22.776795 82.016441 37.561731l-0.299695 0.299695c13.686056 6.593283 23.276286 20.579034 23.276286 36.962342z m-81.716746-286.308304c0-101.596492-82.416033-184.012525-184.012525-184.012524-101.596492 0-184.012525 82.416033-184.012524 184.012524 0 101.596492 82.416033 184.012525 184.012524 184.012525 101.596492 0 184.012525-82.416033 184.012525-184.012525z" p-id="2850"></path></svg>
  `
};
const userIcon = {
  template: `
    <a-icon :component="UserSvg" />
  `,
  data () {
    return {
      UserSvg
    };
  }
};
const UserSvg = {
  template: `
    <svg t="1608012688069" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5240" width="200" height="200"><path d="M494.884571 535.478857a431.396571 431.396571 0 0 1 430.957715 430.957714 40.155429 40.155429 0 1 1-80.310857 0A351.085714 351.085714 0 0 0 494.884571 615.862857a351.085714 351.085714 0 0 0-350.573714 350.646857 40.228571 40.228571 0 0 1-80.457143 0 431.396571 431.396571 0 0 1 431.030857-430.957714z m0-514.340571a257.170286 257.170286 0 0 1 256.877715 256.950857 257.170286 257.170286 0 0 1-256.877715 256.877714 257.170286 257.170286 0 0 1-256.877714-256.877714A257.170286 257.170286 0 0 1 494.884571 21.138286z m0 80.384a176.786286 176.786286 0 0 0-176.566857 176.566857 176.713143 176.713143 0 0 0 176.566857 176.493714A176.713143 176.713143 0 0 0 671.451429 278.089143a176.786286 176.786286 0 0 0-176.566858-176.566857z" p-id="5241"></path></svg>
  `
};

var ua = navigator.userAgent.toLowerCase();
var isSafari = ua.match(/version\/([\d.]+).*safari/);

export default {
  props: {
    m: null,
    d: null,
    showPage: false
  },
  data () {
    return {
      user: {},
      isManager: false,
      menuInfo: infos,
      menuIndex: 0,
      mWidth: 0,
      msgCount: 0,
      userName: global && global.userInfo ? global.userInfo.nickname : null,
      avatar: global && global.userInfo ? global.userInfo.img_url : null,
      showPanel: false,
      icon: [
        "iconfont icon-shebeiguanli",
        "iconfont icon-shishijiankong",
        "iconfont icon-shijianguanli",
        "iconfont icon-jinengzhongxin",
        "iconfont icon-zonglan",
        "iconfont icon-zonglan",
        "iconfont icon-zonglan",
        "iconfont icon-shebeiguanli"
      ]
    };
  },
  mounted () {
    if (this.$router.name == "login") {
      return;
    }
    if (!global || !global.userInfo) {
      var that = this;
      QHPass.signOut(function () {
        that.gotoLoginPage();
      });
      return;
    }
    $(".main-head-popover").hover(
      () => {
        this.showPanel = true;
        this.$nextTick(() => {
          this.setUserHeader(this.m);
        });
      },
      () => {
        this.showPanel = false;
      }
    );
  },
  computed: {
    menuWidth: function () {
      return this.mWidth + "px";
    }
  },
  methods: {
    gotoLoginPage () {
      global.isJumpingToLogin = null;
      global.userInfo = null;
      global.qid = null;
      global.gotoLoginPage(this);
    },
    setUserHeader (qid) {
      for (var i = 0; i < this.d.length; i++) {
        if (this.d[i].qid == qid) {
          var item = this.d[i];
          if (!item.hasOwnProperty("expire_status")) {
            var arr = item.expire_time.split("-");
            if (isSafari) {
              item.expire_time = arr.join("/");
            }
            // debugger
            var expire_time = item.expire_time;

            if (item.expire_time.indexOf(" ") == -1) {
              expire_time = item.expire_time + " 23:59:59";
            }
            var d_ = new Date(expire_time).getTime();
            var n_ = new Date().getTime();
            var c_ = d_ - n_;
            if (c_ > 3600 * 24 * 1000 * 7) {
              //大于一周
              item.expire_status = 1;
            } else if (c_ > 0 && c_ <= 3600 * 24 * 1000 * 7) {
              //小于一周
              item.expire_status = 2;
            } else {
              item.expire_status = 3;
            }
          }
          this.user = item;
          break;
        }
      }
    },
    boxChange (e) {
      this.qid = e;
      global.qid = e;
      window.sessionStorage.setItem("qid", e);
      this.getProductList(e, global.userInfo.qid);
      this.isManager = false;
      for (var i = 0; i < this.d.length; i++) {
        if (this.d[i].qid == e) {
          if (this.d[i].is_owner == 1) {
            this.isManager = true;
          }
          //是否是试用者身份
          global.user_level = this.d[i].user_level;
          break;
        }
      }
      this.setUserHeader(e);
      this.$emit("accountChange");
    },
    // 获取产品列表
    getProductList (qid, account_qid) {
      let data = {
        qid: qid,
        account_qid: account_qid
      };
      global.axios(this, global.ajaxAdd.getProductList, data).then(res => {
        if (res.data) {
          res.data.forEach(item => {
            if (item.type == 2) {
              window.sessionStorage.setItem("productId", item.product_id);
            }
          });
        }
      });
    },
    gotoUser () {
      this.$router.push("user");
    },
    getIndex () {
      var menuIndex = global.getMenuIndex(this.$route.path);
      return menuIndex;
    },
    resize () {
      this.mWidth = window.innerWidth - 440;
      if (this.$refs.container && this.$refs.container.resize) {
        this.$refs.container.resize();
      }
    },
    confirm (e) {
      // console.log('confirm', e)
      var that = this;
      // 退出默认域
      window.sessionStorage.clear();
      this.clearAllCookie();
      QHPass.signOut(function () {
        that.gotoLoginPage();
      });
    },
    cancel (e) {
      console.log("cancel", e);
    },
    changeSelect (e) {
      this.menuIndex = e.key;
    },
    // menu跳转
    handelClickLink (item) {
      this.$router.push("/" + item.path);
      this.scrollTop();
    },
    // 滚动条置顶
    scrollTop () {
      $(".main-container")[0].scrollTop = 0;
    },
    //清除所有cookie函数
    clearAllCookie () {
      var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
      if (keys) {
        for (var i = keys.length; i--;)
          document.cookie = keys[i] + "=0;expires=" + new Date(0).toUTCString();
      }
    }
  },
  components: {
    HeartIcon,
    userIcon,
    centerIcon
  }
};
</script>

<style lang="less">
.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #f7f7f8 !important;
  box-shadow: 0 2px 3px 0 #0000001a;
}
.main {
  padding-top: 50px;
}
.main-head-popover {
  position: relative;
}

.main-head-hover {
  position: absolute;
  width: 270px;
  height: 220px;
  background: #fff;
  box-shadow: 4px 4px 5px #888888;
  right: -80px;
  border-radius: 4px;
}
.main-head-hover-1 {
  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgb(218, 216, 216);
  padding-left: 10px;
}
.main-head-hover-1 span {
  margin-left: 10px;
}
.main-head-hover-2,
.main-head-hover-3,
.main-head-hover-4 {
  padding-left: 20px;
  line-height: 22px;
  margin-bottom: 0;
  margin-top: 10px;
}
.main-head-hover-3 {
  display: flex;
  align-items: center;
}
.main-head-hover-5 {
  position: absolute;
  bottom: 10px;
  right: 30px;
}
.main-head-hover-2 {
  margin-top: 20px;
}
.main-head .ant-select-selection {
  background: 0;
  border: 0;
}
.main-head .ant-select,
.main-head .ant-select,
.main-head .ant-select-arrow {
  font-family: PingFang SC;
  font-size: 12px;
  color: #666666;
  text-align: center;
  letter-spacing: 0;
  line-height: 17px;
}
.main-head {
  height: 50px;
  position: absolute;
  right: 20px;
  top: 0;
  z-index: 21;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.main-head-name {
  max-width: 100px;
  color: #fff;
  line-height: 50px;
  height: 50px;
  margin: 0 0 0 10px;
  padding: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.main-head-line {
  margin: 0 14px;
  display: inline-block;
  color: #ddd;
}
.main-head-quit {
  width: 40px;
}
#components-layout-demo-top-side-2 .logo {
  position: absolute;
  top: 0;
  left: 0;
  width: 60px;
  height: 50px;
  background: #001529 url(https://p1.ssl.qhimg.com/t016fe864d4c99b5c27.png)
    no-repeat center;
  /* background: url(https://p2.ssl.qhimg.com/t017e38f10a9dc8c829.png) no-repeat; */
  background-size: 32px 24px;
  margin: 0;
  float: left;
  img {
    width: 100%;
    height: 100%;
  }
}
.ant-menu-inline-collapsed {
  width: 60px !important;
}
.main-menu-sider {
  flex: 0 0 60px !important;
  max-width: 60px !important;
  min-width: 60px !important;
  width: 60px !important;
}
.main-container {
  background: #f4f9ff;
  // overflow: scroll !important;
}
</style>



// WEBPACK FOOTER //
// src/components/page/main/header.vue